import { RackEnum } from "../../enum";

export class RackIdReq {
    rackId:number;
    
   }

   export class UnitReq{
    unit:string
    unitId?:number
    role?:string
    rackType?:RackEnum
    constructor(unit?:string,
    unitId?:number,
    role?:string,
    rackType?:RackEnum

    ){
        this.unitId=unitId
        this.unit=unit
        this.role=role
        this.rackType=rackType
    }
   }

   export class Rackreq{
    rackId:number
    itemtype:string
    rackPositionId:number
    plantId:number
    email?:string
    role?:string
    externalRefNo?:string


    constructor(rackId:number,plantId:number,itemType:string,rackPositionId?:number,email?:string,role?:string,externalRefNo?:string){
        this.rackId=rackId
        this.itemtype=itemType
        this.plantId=plantId
        this.rackPositionId=rackPositionId
        this.email=email
        this.role=role
        this.externalRefNo=externalRefNo

    }
   }